import { HttpBasicRequest } from 'app/shared/models/http-basic-request.model';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { ContactTypeEnum } from '../enum/contact-type.enum.model';

import { ContactList, ContactVM } from '../models/back-office-admin-common/contact.models';

export class ContactMapper {

  public static mapContact(contacts: ContactVM[]): ContactList {
    const contactList: ContactList = {
      email: [],
      phoneNumber: [],
      social: [],
      webSite: [],
    };
    if (contacts) {
      Object.keys(contactList).forEach(node => {
        switch (node) {
          case 'email':
            let email = [];
            email.push(contacts.find(el => el.type === ContactTypeEnum.administrativeEmail) ?? { externalId: null, id: null, type: ContactTypeEnum.administrativeEmail, value: '' });
            contactList.email = [...email,
            ...contacts.filter(element =>
              (element.type === ContactTypeEnum.administrativeEmail && element.id !== email[0].id) ||
              (element.type === ContactTypeEnum.commercialEmail && element.id !== email[1].id)),
            ...contacts.filter(element =>
              element.type === ContactTypeEnum.email ||
              element.type === ContactTypeEnum.pec
            )];
            break;
          case 'phoneNumber':
            contactList.phoneNumber = contacts.filter(element =>
              element.type === ContactTypeEnum.phone ||
              element.type === ContactTypeEnum.fax ||
              element.type === ContactTypeEnum.mobile
            );
            break;
          case 'webSite':
            contactList.webSite = contacts.filter(element =>
              element.type === ContactTypeEnum.webSite
            );
            break;
          case 'social':
            contactList.social = contacts.filter(element =>
              element.type === ContactTypeEnum.facebook ||
              element.type === ContactTypeEnum.twitter ||
              element.type === ContactTypeEnum.instagram ||
              element.type === ContactTypeEnum.linkedIn
            );
            break;
          default:
            break;
        }
      });
    } else {
      contactList.email.push({ externalId: null, id: null, type: ContactTypeEnum.administrativeEmail, value: '' });
    }
    return contactList;
  }

  public static contactsCreateRequestOld(contactList: ContactList, baseUrl: string, parentId: number = null): HttpBasicRequest[] {
    const contactCreateRequest: HttpBasicRequest[] = [];
    Object.keys(contactList).forEach(node => {
      contactList[node].filter(email1 => !email1.id && email1.value !== '').forEach(contact => {
        const body = {
          type: contact.type,
          value: contact.value
        };
        contactCreateRequest.push({ url: baseUrl + `/contacts`, method: 'post', body: body, parentId });
      });
    });
    return contactCreateRequest;
  }

  public static contactsCreateRequest(contacts: ContactVM[], baseUrl: string, parentId: number = null): HttpBasicRequest[] {
    const contactCreateRequest: HttpBasicRequest[] = [];
    
    contacts
      .filter(contact => !contact.id && contact.value !== '')
      .forEach(contact => {
        const body = {
          type: contact.type,
          value: contact.value
        };
        contactCreateRequest.push({ url: baseUrl + `/contacts`, method: 'post', body: body, parentId });
      });

    return contactCreateRequest;
}

  public static contactsEditRequestOld(contactList: ContactList, cacheContactList: ContactList, baseUrl: string,): HttpBasicRequest[] {
    const contactEditRequest: HttpBasicRequest[] = [];
    Object.keys(contactList).forEach(node => {
      contactList[node].filter(email1 => !!email1.id && cacheContactList[node].some(email2 => email1.id === email2.id) && !UtilityFunctions.isEquals(email1, cacheContactList[node].find(email2 => email1.id === email2.id))).forEach(contact => {
        contactEditRequest.push({ url: baseUrl + `/contacts/${contact.id}`, method: 'put', body: contact });
      });
    });
    return contactEditRequest;
  }

  public static contactsEditRequest(contacts: ContactVM[], cacheContacts: ContactVM[], baseUrl: string): HttpBasicRequest[] {
    const contactEditRequest: HttpBasicRequest[] = [];
    
    contacts
      .filter(contact => !!contact.id && cacheContacts.some(cacheContact => contact.id === cacheContact.id) &&
        !UtilityFunctions.isEquals(
          contact, 
          cacheContacts.find(cacheContact => contact.id === cacheContact.id)
        )
      )
      .forEach(contact => {
        contactEditRequest.push({ 
          url: baseUrl + `/contacts/${contact.id}`, 
          method: 'put', 
          body: contact 
        });
      });

    return contactEditRequest;
  }

  public static contactsDeleteRequestOld(contactList: ContactList, cacheContactList: ContactList, baseUrl: string): HttpBasicRequest[] {
    const contactDeleteRequest: HttpBasicRequest[] = [];
    Object.keys(contactList).forEach(node => {
      cacheContactList[node].filter((email1) => !contactList[node].some(email2 => email1.id === email2.id)).forEach((contact: ContactVM) => {
        contactDeleteRequest.push({ url: baseUrl + `/contacts/${contact.id}`, method: 'delete' });
      });
    });
    return contactDeleteRequest;
  }

  public static contactsDeleteRequest(contacts: ContactVM[], cacheContacts: ContactVM[], baseUrl: string): HttpBasicRequest[] {
    const contactDeleteRequest: HttpBasicRequest[] = [];
    
    cacheContacts
      .filter(cachedContact => cachedContact.id && !contacts?.some(currentContact => currentContact.id && currentContact.id === cachedContact.id))
      .forEach(contactToDelete => {
        contactDeleteRequest.push({ 
          url: baseUrl + `/contacts/${contactToDelete.id}`, 
          method: 'delete' 
        });
      });

    return contactDeleteRequest;
}

  public static contactsCustomerDeleteRequestOld(contactList: ContactList, cacheContactList: ContactList, baseUrl: string, customerId: number, locationId: number): HttpBasicRequest[] {
    const contactDeleteRequest: HttpBasicRequest[] = [];
    Object.keys(contactList).forEach(node => {
      cacheContactList[node].filter((email1) => !contactList[node].some(email2 => email1.id === email2.id)).forEach(contact => {
        contactDeleteRequest.push({ url: baseUrl + `/customers/${customerId}/contact?locationId=${locationId}&contactId=${contact.id}`, method: 'delete' });
      });
    });
    return contactDeleteRequest;
  }

  public static contactsCustomerDeleteRequest(contacts: ContactVM[], cacheContacts: ContactVM[], baseUrl: string, customerId: number, locationId: number): HttpBasicRequest[] {
    const contactDeleteRequest: HttpBasicRequest[] = [];
    
    cacheContacts
      .filter(cachedContact => !contacts.some(currentContact => currentContact.id === cachedContact.id))
      .forEach(contactToDelete => {
        contactDeleteRequest.push({ 
          url: baseUrl + `/customers/${customerId}/contact?locationId=${locationId}&contactId=${contactToDelete.id}`, 
          method: 'delete' 
        });
      });

    return contactDeleteRequest;
  }


  public static contactsAgencyDeleteRequestOld(contactList: ContactList, cacheContactList: ContactList, baseUrl: string, agencyId: number): HttpBasicRequest[] {
    const contactDeleteRequest: HttpBasicRequest[] = [];
    Object.keys(contactList).forEach(node => {
      cacheContactList[node].filter((email1) => !contactList[node].some(email2 => email1.id === email2.id)).forEach(contact => {
        contactDeleteRequest.push({ url: baseUrl + `/agencies/${agencyId}/contact/${contact.id}`, method: 'delete' });
      });
    });
    return contactDeleteRequest;
  }

  public static contactsAgencyDeleteRequest(contacts: ContactVM[], cacheContacts: ContactVM[], baseUrl: string, agencyId: number): HttpBasicRequest[] {
    const contactDeleteRequest: HttpBasicRequest[] = [];
    
    cacheContacts
      .filter(cachedContact => !contacts.some(currentContact => currentContact.id === cachedContact.id))
      .forEach(contactToDelete => {
        contactDeleteRequest.push({ 
          url: baseUrl + `/agencies/${agencyId}/contact/${contactToDelete.id}`, 
          method: 'delete' 
        });
      });

    return contactDeleteRequest;
  }


}
